import JobDetails from './JobDetails.react'

export default JobDetails
